import { API, standardResponse } from "./middleware";

export async function searchDesignSamples(dataSearch) {
  return API.post("api/designSample/search", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function searchDesignSamplesPublic(dataSearch) {
  return API.post("/api/public/designSample/search", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function fetchDesignSampleCreate(data) {
  return API.post("/api/designSample/create", data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchDesignSampleUpdate(id, data) {
  return API.put(`/api/designSample/update/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchDesignSampleToggleStatus(id) {
  return API.put(`/api/designSample/changeStatus/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchDesignSampleDelete(id) {
  return API.delete(`/api/designSample/delete/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}
